import React from 'react';
import './index.css';

const ControlPanel: React.FC<{
  isDrawing: boolean;
  polygonsCount: number;
  onToggleDrawing: () => void;
  onClearPolygons: () => void;
  onSavePolygons: () => void;
  isLoading: boolean;
  isSaved: boolean;
  isFullScreen: boolean;
  onToggleFullScreen: () => void;
}> = ({ 
  isDrawing, 
  polygonsCount, 
  onToggleDrawing, 
  onClearPolygons, 
  onSavePolygons, 
  isLoading, 
  isSaved,
  isFullScreen,
  onToggleFullScreen 
}) => {
  return (
    <div className="control-panel">
      <div style={{ flex: 1, minWidth: '200px' }}>
        <button
          onClick={onToggleDrawing}
          className={`draw-button ${isDrawing ? 'drawing' : ''}`}
          disabled={isLoading || (polygonsCount > 0 && !isDrawing)}
        >
          {isDrawing ? 'Cancel Drawing' : 'Draw Delivery Zone'}
        </button>
        
        {isDrawing && (
          <div style={{ fontSize: '0.875rem', color: '#6b7280', marginTop: '0.5rem' }}>
            Click on the map to add points. Connect back to the first point to complete.
          </div>
        )}
      </div>
      
      <button
        onClick={onClearPolygons}
        className="clear-button"
        disabled={polygonsCount === 0 || isLoading}
      >
        Clear Zone ({polygonsCount})
      </button>

      <button
        onClick={onSavePolygons}
        className="save-button"
        disabled={polygonsCount === 0 || isLoading || isSaved} 
      >
        {isLoading ? 'Saving...' : isSaved ? 'Saved' : 'Save Zone'} 
      </button>
    </div>
  );
};

export default ControlPanel;